import { useContext, useMemo } from "react";
import { ConfiguratorContext } from "../../contexts/ConfiguratorContext";
import { PAYMENTS_PNM_INTEGRATION_ALLOWED_KEY } from "../constants/Configurator.constants";
import { findInArray, parseConfigBoolean } from "../utils/utility-functions";

export const usePnmIntegrationConfig = () => {
  const { edittedFields } = useContext(ConfiguratorContext);

  return useMemo(() => {
    const integrationField = findInArray(
      edittedFields,
      "key",
      PAYMENTS_PNM_INTEGRATION_ALLOWED_KEY,
    );

    return {
      pnmIntegrationEnabled: parseConfigBoolean(integrationField?.value),
    };
  }, [edittedFields]);
};
